import {APP_INITIALIZER, FactoryProvider} from '@angular/core';

/**
 * Interface to implement for adding initialization logic to service.
 */
export interface OnAppInitInterface<T = void> {

  /**
   * Called during application initialization.
   * @see https://angular.io/api/core/APP_INITIALIZER
   */
  onAppInit(): T;

}

/**
 * Registers a service so that its onAppInit method is called during application initialization.
 * @see https://angular.io/api/core/APP_INITIALIZER
 * @example Usage:
 * <code>
 * @NgModule({
 *   ...
 *   providers: [
 *     ...
 *     ExampleService,
 *     serviceInitializer(ExampleService),
 *     ...
 *   ],
 *   ...
 * }
 * </code>
 */
export function serviceInitializer<T extends OnAppInitInterface>(
  serviceType: new (...args: Array<any>) => T,
): FactoryProvider {
  return {
    provide: APP_INITIALIZER,
    deps: [serviceType],
    useFactory: (service: T) => (() => service.onAppInit()),
    multi: true,
  };
}
